import { Message } from "../../../Services/MessageBus/Message";
import { RawChatEntry } from "../../Models/RawChatEntry";


export class AddEntryCommand extends Message
{
	constructor(Id: string, Entry: RawChatEntry, Folder: string)
	{
		super("AddEntry", { Id, Folder, Entry });
	}
}
